import React from 'react';
import './index.css';
import {Message, Button, Popconfirm,Modal,Row,Col,Select,FormControl,Tabs } from 'tinper-bee';
import Radio from 'bee-radio';
import 'bee-radio/build/Radio.css';
import Limits from './limits'
// import LoadingState from 'bee-loading-state';
// import 'bee-loading-state/build/Loadingstate.css';
import * as util from '../../utils';
import {Link} from "react-router-dom";
const Option = Select.Option;
const TabPane = Tabs.TabPane;
class Basic extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            editData: {},
            editVisible: false,
            editArea: null,
            editClassify: null,
            editType: null,
            editInfo: null,
            editIsPublic: null,
        };
    }
    async init (){
        const result: any = await util.get('/package/listByUser');
        const data = result.data;
        this.setState({pkg: data.creator.concat(data.develop).concat(data.admin)})
    }
    async getSelect (){
        const result: any = await util.get('/home/getFilter');
        const data = result.data;
        this.setState({
            areaList: data.area,
            classifyList: data.classify,
            typeList: data.type,
        })
    }

    componentDidMount() {
        this.init();
        this.getSelect();
    }

    async refresh(name) {
        const result: any = await util.post('/package/sync', {name});
        if(result.status === 200) {
            Message.create({content: '同步成功，请到详情页查看组件最新状态!', color: "success"});
        } else {
            Message.create({content: result.message, color: "danger"});
        }
    }
    async del(id){
        const result: any = await util.post('/package/delPackage', {id});
        if(result.status === 200) {
            this.init();
            Message.create({content: '删除成功!', color: "success"});
        } else {
            Message.create({content: result.message, color: "danger"});
        }
    }

    async release() {
        const {tenantId, releaseData} = this.state
        const result: any = await util.post('/package/release', {
            tenantId,
            id: releaseData.id
        });
        if(result.status === 200) {
            this.setState({
                releaseInfoVisible: true,
                releaseVisible: false,
                releaseCDN: result.data,
                releaseData: null,
            })
            this.init();
        } else {
            Message.create({content: result.message, color: "danger"});
        }
    }
    edit(item){
        this.setState({
            editVisible: true,
            editData: item,
            editArea : item.area,
            editClassify : item.classify,
            editType : item.type,
            editInfo : item.info,
            editIsPublic : item.isPublic,
        })
    }
    async editSave() {
        const {
            editArea = null,
            editClassify = null,
            editType = null,
            editInfo = null,
            editIsPublic = null,
            editData = {}
        } = this.state;
        const data = {
            id: editData.id,
            area: editArea,
            classify: editClassify,
            type: editType,
            info: editInfo,
            isPublic: editIsPublic,
        }
        const result: any = await util.post('/package/edit', data);
        if(result.status === 200) {
            Message.create({content: '修改成功!', color: "success"});
            this.init();
            this.setState({editVisible: false})
        } else {
            Message.create({content: result.message, color: "danger"});
        }
    }

    releaseClick(item) {
        this.setState({
            releaseVisible: true,
            releaseData: item,
            tenantId: item.tenantId
        })
    }
    editChang (type, value) {
        this.setState({[type]: value})
    }

    render() {
        const {
            pkg = [],
            areaList = [],
            typeList = [],
            classifyList = [],
            editArea = null,
            editClassify = null,
            editType = null,
            editInfo = null,
            editIsPublic = null,
            limitId = '',
            userVisible = false,
            tenantId,
            releaseData
        } = this.state;
        const {tenantList} = this.props;
        return (
            <React.Fragment>
                <Limits refresh={() =>{
                    this.init()
                    this.setState({userVisible: false})
                }} id={limitId} visible={userVisible}/>
                <Modal
                    show = { this.state.releaseInfoVisible }
                    onHide = { () => {this.setState({releaseInfoVisible : false})} } >
                    <Modal.Header closeButton closeButtonProps={{fieldId:'closeBtn'}}>
                        <Modal.Title>手动发布成功</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>CDN地址:</p>
                        <div style={{wordBreak: 'break-all'}}>{this.state.releaseCDN}</div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={ () => {this.setState({releaseInfoVisible : false}) }} colors="secondary" style={{marginRight: 8}}>取消</Button>
                        <Button colors='primary' onClick={  () => {this.setState({releaseInfoVisible : false}) }} bordered>确认</Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show = { this.state.editVisible }
                    onHide = { () => this.setState({editVisible: false}) }
                    width={600}
                >
                    <Modal.Header closeButton closeButtonProps={{fieldId:'closeBtn'}}>
                        <Modal.Title>修改信息</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div style={{marginBottom: '20px'}} className='edit-row'>
                            <div className={'leftTitle'}><span className={'red'}>*</span>所属领域：</div>
                            <div className={'rightContent'}>
                                <Select value={editArea}  onChange={(e) => this.editChang('editArea', e)}>
                                    {
                                        areaList.map(item => item.value === 'all' ? null : <Option value={item.value}>{item.title}</Option>)
                                    }
                                </Select>
                            </div>
                        </div>
                        <div className='edit-row'>
                            <Col className={'leftTitle'}><span className={'red'}>*</span>物料类型：</Col>
                            <div className={'rightContent'}>
                                <Select value={editType} onChange={(e) => this.editChang('editType', e)}>
                                    {
                                        typeList.map(item => item.value === 'all' ? null : <Option value={item.value}>{item.title}</Option>)
                                    }
                                </Select>
                            </div>
                        </div>
                        <div className='edit-row'>
                            <div className={'leftTitle'}><span className={'red'}>*</span>内置分类：</div>
                            <div className={'rightContent'}>
                                <Select value={editClassify} onChange={(e) => this.editChang('editClassify', e)}>
                                    {
                                        classifyList.map(item => item.value === 'all' ? null : <Option value={item.value}>{item.title}</Option>)
                                    }
                                </Select>
                            </div>
                        </div>

                        <div className='edit-row'>
                            <div className={'leftTitle'}><span className={'red'}>*</span>简介：</div>
                            <div className={'rightContent'}>
                                <FormControl value={editInfo} onChange={(e) => this.editChang('editInfo', e)} type='textArea' />
                            </div>
                        </div>

                        <div className='edit-row'>
                            <div className={'leftTitle'}><span className={'red'}>*</span>可见范围：</div>
                            <div className={'rightContent'}>
                                <Radio.RadioGroup
                                    name="fruits"
                                    value={editIsPublic}
                                    onChange={(e) => this.editChang('editIsPublic', e)}
                                >
                                    <Radio inverse value="private">私有</Radio>
                                    <Radio inverse value="public">公开</Radio>
                                </Radio.RadioGroup>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={ () => this.setState({editVisible: false}) } colors="secondary" style={{marginRight: 8}}>取消</Button>
                        <Button onClick={ () => this.editSave() }  colors={'primary'}>确认</Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show = { this.state.releaseVisible }
                    onHide = { () => this.setState({releaseVisible: false}) } >
                    <Modal.Header closeButton closeButtonProps={{fieldId:'closeBtn'}}>
                        <Modal.Title>选择发布租户</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Row className='edit-row'>
                            <div className={'leftTitle'}>选择租户：</div>
                            <div className={'rightContent'}>
                                <Select disabled={releaseData && releaseData.tenantId } value={tenantId} onChange={(e) => this.editChang('tenantId', e)}>
                                    {
                                        tenantList.map(item => <Option value={item.tenantId}>{item.name}</Option>)
                                    }
                                </Select>
                            </div>
                        </Row>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={ () => this.setState({releaseVisible: false}) } colors="secondary" style={{marginRight: 8}}>取消</Button>
                        <Button onClick={ () => this.release() }  colors={'primary'}>确认</Button>
                    </Modal.Footer>
                </Modal>
                <div className='pkg-list'>
                {
                    pkg.map(item =>
                        <div className='package-detail'>
                            <p className='name'>{item.name}</p>
                            <p className='info'>{item.info || '这是物料的介绍'}</p>
                            <div className='bottom-info2'>
                                <span className='item'>下载数量: <span className='fontW'>{item.download || 0}</span></span>
                                <span className='item'>version: <span className='fontW'>{item.latestVersion || '--'}</span></span>
                                <span className='item'>Published: <span className='fontW'>{item.latestTime || '--'}</span></span>
                            </div>
                            <div style={{
                                width: 940,
                                height: 30,
                                margin: '20px 0',
                                textAlign: 'right'
                            }}>
                                {
                                    item.nexus !== 'cli' ? <Button bordered onClick={() => this.refresh(item.name)}  style={{ marginRight: 5}}>同步</Button> : null
                                }
                                {
                                    item.nexus === 'cli' ? <Button className='mainButton' colors='primary' onClick={() => this.releaseClick(item)}   style={{marginRight: 5}}>发布到YonBuilder</Button> : null
                                }
                                <Button bordered onClick={() => this.edit(item)}  style={{marginRight: 5}}>编辑</Button>
                                {
                                    item.identity === 'develop' ? null : <Button bordered style={{marginRight: 5}} onClick={() => {
                                        this.setState({
                                            limitId: item.id,
                                            userVisible: true,
                                        })
                                    }}>权限</Button>
                                }
                                {/* {
                                    item.identity === 'creator'
                                        ?
                                        <Popconfirm
                                            content={<div style={{textAlign: 'center'}}>您确定删除该组件吗？</div>}
                                            onClose={() => this.del(item.id)}
                                        >
                                            <Button bordered>删除</Button>
                                        </Popconfirm>
                                        :
                                        null
                                } */}
                            </div>
                        </div>
                    )
                }
                </div>
            </React.Fragment>
        );
    }
}

export default Basic;
